var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.notifications),function(notification){return _c('div',{key:notification.name,attrs:{"id":"example-1"}},[_c('div',{staticClass:"my-4 border-bottom"},[_c('label',{staticClass:"switch",on:{"click":function($event){return _vm.updateNotificationSettings({
            label: notification.label,
            value: !notification.value,
          })}}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":notification.value}}),_c('span',{staticClass:"slider round"})]),_c('span',{staticClass:"ml-4"},[_vm._v(_vm._s(notification.name))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }